import React from 'react'
import CardNew from 'presentation/shared/components/CardNew'
import * as S from './styles'
import Divider from 'presentation/shared/components/DividerNew'
import { ReactComponent as NoDataIcon } from 'presentation/assets/icons/no-data.svg'
import { TooltipNew } from 'presentation/shared/components/TooltipNew'

interface OtherIndicatorsCardProps {
  value: string
  title: string
  textInfo?: string
  generalAverage?: string
  variant?:
    | 'positive'
    | 'negative'
    | 'equal'
    | 'indicatorPositive'
    | 'indicatorNegative'
    | 'indicatorEqual'
    | 'noData'
}

export const OtherIndicatorsCard = ({
  value,
  title,
  textInfo,
  generalAverage,
  variant
}: OtherIndicatorsCardProps) => {
  const hasNoData = variant === 'noData'

  return (
    <CardNew
      background="neutral25"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        gap: '8px',
        width: '100%',
        minWidth: '150px',
        minHeight: '175px'
      }}
    >
      {hasNoData ? (
        <TooltipNew
          text="Ainda não há informações relacionadas a este indicador"
          className="icon"
          type="neutral"
        >
          <S.ValueContainer
            variant={variant}
            style={{
              fontSize: '16px',
              display: 'flex',
              gap: '4px',
              alignItems: 'center'
            }}
          >
            <NoDataIcon />
            {value}
          </S.ValueContainer>
        </TooltipNew>
      ) : (
        <S.ValueContainer variant={variant}>{value}</S.ValueContainer>
      )}
      <S.OtherIndicatorsCardTitle>{title}</S.OtherIndicatorsCardTitle>
      {textInfo && <S.textInfo>{textInfo}</S.textInfo>}
      <Divider marginTop="auto" marginBottom="8px" />
      <S.AverageSpecialty>Média da sua especialidade</S.AverageSpecialty>
      {!!generalAverage &&
        (hasNoData ? (
          <S.GeneralAverage style={{ fontSize: '14px' }}>
            {generalAverage}
          </S.GeneralAverage>
        ) : (
          <S.GeneralAverage>{generalAverage}</S.GeneralAverage>
        ))}
    </CardNew>
  )
}
